import { ApprovingInvoiceReportPaymentInfoResponse } from 'ap-openapi';
import { useEffect } from 'react';
import { useBusinessDocumentsContext } from '../context/BusinessDocumentsContext';

export const useSetBusinessDocumentsData = (
  data: ApprovingInvoiceReportPaymentInfoResponse | undefined
) => {
  const { setData } = useBusinessDocumentsContext();

  useEffect(() => {
    if (!data) return;
    setData(data);
  }, [data, setData]);
};
